<template>
  <div class="nested-fields">
    <div class="residents__row">
      <i class="icon person" ></i>

      <div>
            <div class="form-group-wrapper">
              <div
                  class="form-group form-group--pill adaptive-placeholder string required first_name"
                >

                <label
                  class="control-label string required"
                  tag="div"
                  for="first_name"
                  >
                  First name
                </label>
                <div class="form-control-wrapper">
                  <input
                    id="first_name"
                    :value="first_name"
                    class="form-control empty string required indent-name"
                    type="text"
                    name="contact[first_name]"
                    :class="{ 'not-empty': first_name }"
                    @input="$emit('update:first_name', $event.target.value)"
                    placeholder="Enter first name"
                  />
                </div>
              </div>
            </div>
        </div>
        <div>
            <div class="form-group-wrapper">
              <div
                  class="form-group form-group--pill adaptive-placeholder string required full_name"
                >
                <label
                  class="control-label string required"
                  tag="div"
                  for="full_name"
                  >
                  Last name
                </label>
                <div class="form-control-wrapper">
                  <input
                    id="full_name"
                    :value="last_name"
                    class="form-control empty string required indent-name"
                    type="text"
                    name="contact[last_name]"
                    :class="{ 'not-empty': last_name }"
                    @input="$emit('update:last_name', $event.target.value)"
                    placeholder="Enter last name"
                  />
                </div>
              </div>
            </div>
        </div>
        <div>
            <div class="form-group-wrapper">

              <div
                class="form-group form-group--pill form-group--select required reservation_residents_bike_rental"
              >
                <label class="control-label select required" for="bike_rental"
                  >Bike rental</label
                >
                <div class="form-control-wrapper">
                  <select
                    id="bike_rental"
                    class="form-control select required"
                    :value="bike_rental"
                    @change="$emit('update:bike_rental', $event.target.value)"
                  >
                    <option value="">Select </option>
                    <option value="own-bike">Own bike</option>
                    <option value="standard-bike">Standard bike</option>
                    <option v-if="has_gravel" value="road-cross">Road/Cross</option>
                    <option value="e-bike">E-bike</option>
                    <option value="premium-e-bike">Premium E-bike</option>
                  </select>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Resident",
  props: ["identifier", "first_name", "last_name", "bike_rental", "has_gravel"],
};
</script>


<style lang="scss" scoped>
.icon {
  font-size: 32px
}
</style>
